const AFFILIATE_URL =
  "https://www.viator.com/?pid=P00251875&mcid=42383&medium=link&campaign=TCvisitor";
const SESSION_KEY = "tc_popunder_fired";

// In-memory fallback flag — sessionStorage can be unavailable or cleared in
// some browser contexts, which would cause the pop-under to fire repeatedly.
let firedInMemory = false;

function wasFired(): boolean {
  if (firedInMemory) return true;
  try {
    return !!sessionStorage.getItem(SESSION_KEY);
  } catch {
    return false;
  }
}

function markFired(): void {
  firedInMemory = true;
  try {
    sessionStorage.setItem(SESSION_KEY, "1");
  } catch {
    // Ignore — in-memory flag still guards within this page.
  }
}

export function popUnderAlreadyFired(): boolean {
  return wasFired();
}

/**
 * Fire the pop-under: re-open the current page in a new tab and navigate the
 * original tab to the Viator affiliate URL. No-op if already fired this session.
 * Returns true if successfully fired.
 */
export function firePopUnder(): boolean {
  if (typeof window === "undefined") return false;
  if (wasFired()) return false;

  // Mark immediately so rapid consecutive clicks can't double-fire.
  markFired();

  const currentUrl = window.location.href;
  const newTab = window.open(currentUrl, "_blank");
  if (newTab) {
    window.location.href = AFFILIATE_URL;
    return true;
  }
  // Pop-up blocked: reset the flag so a later attempt can retry.
  firedInMemory = false;
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // Ignore.
  }
  return false;
}
